import arc from './arc';
import area from './area';
import group from './group';
import image from './image';
import line from './line';
import path from './path';
import rect from './rect';
import rule from './rule';
import shape from './shape';
import symbol from './symbol';
import text from './text';
import trail from './trail';

export default {
  arc:     arc,
  area:    area,
  group:   group,
  image:   image,
  line:    line,
  path:    path,
  rect:    rect,
  rule:    rule,
  shape:   shape,
  symbol:  symbol,
  text:    text,
  trail:   trail
};



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/marks/index.js
// module id = 107
// module chunks = 0